import axios from '../api/axios';

export interface AdvisorActivity {
  key: string;
  name: string;
  description: string;
  eligibleShips: number;
}

export interface AdvisorReceipt {
  activity: string;
  stat: string;
  label: string;
  display?: string | null;
  percentile: number;
  weight: number;
}

export interface AdvisorFacility {
  key: string;
  label: string;
  status: 'yes' | 'no' | 'pending';
  count: number;
  detail?: string | null;
}

export interface AdvisorResult {
  slug: string;
  name: string;
  manufacturer?: string | null;
  imageUrl?: string | null;
  sizeClass?: string | null;
  role?: string | null;
  crewMin?: number | null;
  crewMax?: number | null;
  score: number;
  activityScores: Record<string, number>;
  receipts: AdvisorReceipt[];
  facilities: AdvisorFacility[];
  priceAuec?: number | null;
  priceUsd?: number | null;
}

export interface AdvisorResponse {
  weightsVersion: number;
  activities: string[];
  eligibleCount: number;
  results: AdvisorResult[];
}

export interface AdvisorRankRequest {
  activities: string[];
  budgetAuec?: number;
  budgetUsd?: number;
  buyableOnly?: boolean;
  maxSize?: string;
  maxCrew?: number;
}

export const advisorService = {
  async getActivities(): Promise<AdvisorActivity[]> {
    const res = await axios.get<AdvisorActivity[]>('/advisor/activities');
    return res.data;
  },

  async rank(request: AdvisorRankRequest): Promise<AdvisorResponse> {
    const res = await axios.post<AdvisorResponse>('/advisor/rank', request);
    return res.data;
  },
};
